export default {
  submissionHistory: {
    byId: {},
    allIds: []
  },
  validationRulesResult: {
    byId: {},
    allIds: []
  },
  lenders: [],
  creditSubjects: [],
  creditReports: {
    byId: {},
    allIds: []
  },
  additionalReports: [],
  participants: {
    agent: {},
    submissionAgents: {
      byId: {},
      allIds: []
    }
  },
  coBrokering: {
    coBrokeringHistory: [],
    brokerages: [],
    brokerageCount: 0,
    agents: [],
    totalAgents: 0,
    loadingAgents: false
  },
  requestingCreditBureau: false,
  documentForms: {
    byId: {},
    allIds: []
  },
  editingDocumentForm: {},
  feesCosts: {
    first: [],
    second: [],
    third: []
  },
  feesCalculatedDetails: {
    first: [],
    second: [],
    third: []
  },
  feeStructure: {
    amount: 0,
    amountEditable: true,
    comment: "",
    deductFromPrincipal: false,
    defaultFee: false,
    feeName: "",
    includeInAPR: false,
    includeInAPREditable: true
  },
  feesSavingStatus: false,
  currentFeesMortgageType: "first",
  mpp: {
    allIds: [],
    byId: {}
  },
  lenderResponses: [],
  lenderSubmissionData: {
    dealType: ""
  },
  lenderNotes: {},
  currentManualResponseId: "",
  submissionManualResponse: {
    byId: {},
    allIds: []
  },
  emptyCommissionFee: {
    commissionsFeeId: "",
    type: null,
    basisPoints: null,
    amount: null,
    fundsReceived: null,
    description: "",
    default: false,
    mortgageType: ""
  },
  totalCommissionFees: 0,
  loadingTotalCommissionFees: false
};